import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import BurgerMenu from './BurgerMenu';
import {debounce} from 'lodash';

const Navbar = () => {
    const [viewPortWidth, setViewPortWidth] = useState(window.innerWidth);
    useEffect(() => {
        const setWidth = debounce(() => {setViewPortWidth(window.innerWidth); }, 500);
        window.addEventListener('resize', setWidth);

        return () => {setWidth.cancel(); window.removeEventListener('resize', setWidth); }
    }, []);

    const renderNavLinks = () => {
        return (<>
            <NavLink to="/about">About</NavLink>
            <NavLink to="https://www.pfizer.com/contact" target="_blank">Contact Us<img className="external-link-icon" src="/assets/icons/external-link.svg" alt="" aria-hidden="true" /></NavLink>
            <NavLink to="/retirees">Retirees</NavLink>
        </>);
    }

    return (
        <div className="navbar">
            <div className="d_1">
                <NavLink to="/"><div className="img-container"><img src="/assets/logo_pfizer.svg" alt="logo" /></div></NavLink>
                <div className="d_1_2">Alumni Community</div>
            </div>
            { viewPortWidth < 1000 ? <BurgerMenu renderNavLinks={renderNavLinks} /> : (    
                <div className="d_2">
                    <div className="nav-links"> {renderNavLinks()} </div>
                    <a target="_blank" href="https://pfizer.almaconnect.com/" rel="noreferrer"><button>Signup/Login</button></a>
                </div>
                )
            }
        </div>
    );
};
export default Navbar;